import { H3 } from '@src/core';
import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

interface AccordionSmoothProps {
  title: string;
  content: string;
}

export const AccordionWhite = ({ title, content }: AccordionSmoothProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState<boolean>(false);

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  return (
    <div>
      <button
        className="flex items-center w-full justify-between px-4 pt-4 pb-3 mt-2 bg-white"
        onClick={toggleAccordion}
        type="button"
      >
        <H3 className="text-darkblue w-5/6 text-left">{title}</H3>
        <FaChevronDown
          className={`w-8 h-8 ease-linear ${isAccordionOpen ? 'rotate-180' : ''}`}
          color="#003F88"
        />
      </button>
      <div
        className={`shadow-3xl shadow-cyan-500/50 mb-6 border-gray border-t-2 bg-white rounded-none px-4 overflow-hidden  ${
          isAccordionOpen ? 'max-h-96 py-4' : 'max-h-0 py-0 invisible'
        } ease-linear`}
      >
        {content}
      </div>
    </div>
  );
};
